<template>
  <div class="gastos-planificados">
    <div class="container py-4">
      <h1 class="mb-4">Gastos Planificados</h1>
      
      <div class="row mb-4">
        <div class="col-md-12">
          <div class="card bg-light">
            <div class="card-body">
              <h5 class="card-title">¿Qué son los gastos planificados?</h5>
              <p class="card-text">
                Los gastos planificados te permiten distribuir un gasto elevado en varios pagos a lo largo del tiempo.
                Por ejemplo, si has comprado un móvil de 1200€ y quieres pagarlo en 6 cuotas mensuales de 200€,
                puedes crear un gasto planificado y el sistema generará automáticamente los pagos correspondientes.
                Si el gasto es compartido, elige <strong>Mitad</strong> para contabilizar solo tu parte, igual que en los gastos habituales.
              </p>
              <p class="card-text">
                <strong>Características:</strong>
              </p>
              <ul>
                <li>Distribuye gastos elevados en varios pagos</li>
                <li>Programa la periodicidad (semanal, quincenal, mensual)</li>
                <li>Registra pagos manualmente cuando lo necesites</li>
                <li>Elige si el importe se guarda como Total o Mitad</li>
                <li>Visualiza el progreso de cada gasto planificado</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="!showForm" class="row">
        <div class="col-md-12">
          <GastoPlanificadoList 
            @nuevo="crearNuevo" 
            @refresh="cargarGastosPlanificados"
            @editar="editarGasto" />
        </div>
      </div>
      
      <div v-if="showForm" class="row">
        <div class="col-md-12">
          <GastoPlanificadoForm 
            :gasto="gastoSeleccionado"
            :editMode="!!gastoSeleccionado"
            @guardar="guardarGasto"
            @cancelar="cancelForm" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import GastoPlanificadoForm from '@/components/GastoPlanificadoForm.vue';
import GastoPlanificadoList from '@/components/GastoPlanificadoList.vue';

export default {
  name: 'GastosPlanificados',
  components: {
    GastoPlanificadoForm,
    GastoPlanificadoList
  },
  setup() {
    const showForm = ref(false);
    const gastoSeleccionado = ref(null);
    
    // Crear nuevo gasto planificado
    const crearNuevo = () => {
      gastoSeleccionado.value = null;
      showForm.value = true;
    };
    
    // Editar gasto planificado
    const editarGasto = (gasto) => {
      gastoSeleccionado.value = gasto;
      showForm.value = true;
    };
    
    // Cancelar formulario
    const cancelForm = () => {
      showForm.value = false;
      gastoSeleccionado.value = null;
    };
    
    // Guardar gasto planificado
    const guardarGasto = (gasto) => {
      console.log('Gasto guardado:', gasto);
      showForm.value = false;
      gastoSeleccionado.value = null;
      // Recargar la lista de gastos planificados
      cargarGastosPlanificados();
    };
    
    // Cargar gastos planificados
    const cargarGastosPlanificados = () => {
      console.log('Recargando lista de gastos planificados');
      // Esta función se llama cuando se realiza alguna acción que requiere refrescar los datos
    };
    
    return {
      showForm,
      gastoSeleccionado,
      crearNuevo,
      editarGasto,
      cancelForm,
      guardarGasto,
      cargarGastosPlanificados
    };
  }
};
</script>

<style scoped>
.gastos-planificados {
  min-height: calc(100vh - 56px);
  background-color: #f8f9fa;
}

h1 {
  color: #343a40;
  border-bottom: 2px solid #007bff;
  padding-bottom: 0.5rem;
  display: inline-block;
}
</style> 